import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './style.sass';

const organizations = [
    {
        key: 'sponsors',
        headerSingular: 'Sponsor',
        headerPlural: 'Sponsorzy'
    },
    {
        key: 'organizers',
        headerSingular: 'Organizator',
        headerPlural: 'Organizatorzy'
    },
    {
        key: 'partners',
        headerSingular: 'Partner',
        headerPlural: 'Partnerzy'
    },
    {
        key: 'friends',
        headerSingular: 'Zaprzyjaźniona inicjatywa',
        headerPlural: 'Zaprzyjaźnione inicjatywy'
    },
];

export default ({event}) => {
    let orgN = 0;
    return organizations.map((definition) => event.data && event.data[definition.key] !== undefined && event.data[definition.key] !== null &&
        // Note: Can't just use map's `i` instead of `orgN` because `i` is the unfiltered iteration count.
        <section className={classNames(styles.root, {[styles.first]: orgN++ === 0})}>
            <div className="larger grid">
                <h3 className="g-type-title-section line-flat">{event.data[definition.key].length === 1 ? definition.headerSingular : definition.headerPlural}</h3>
                <ul>
                    {event.data[definition.key].map((organization, i) =>
                        <li key={i}>
                            <a href={organization.homepage}>
                                <img src={organization.logo.normal}/>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </section>
    )
}



// WEBPACK FOOTER //
// ./src/modules/Events/pages/Show/Organizations/index.js